import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import styled from 'styled-components';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import ListItems from '../../../RoleListBox/ListItems';
import EntListItems from '../../../EntitlementListBox/ListItems';
import { getSubscriptionDetails } from '../../../../../actions/entitlementsActions';
import { getRoleDetails } from '../../../../../actions/roleActions';
import CopyIcon from '../../../shared/CopyIcon';
import { getActivationKey } from '../../../../../actions/activationKeyActions';
import { CopyDataToClipBoard } from '../../../../../util/CommonUtils';
import IconCheckboxEmpty from '../../../../autocode/ACShared/IconCheckBoxEmpty';
import IconCheckboxCheck from '../../../../autocode/ACShared/IconCheckBoxCheck';

const CheckLabel = styled.div`
  font-weight: 'normal';
  font-size: '16px';
  line-height: '15px';
  color: #333333;
  width: 100%;
  word-break: break-word;
  user-select: none;
`;

const ViewActivationKey = ({
  accountDetail,
  selectedKey,
  activeRoles,
  activeEntitlements,
  availableRoles,
  availableEntitlements,
}) => {
  const [itemsRight, setItemsRight] = useState([]);
  const [itemsLeft, setItemsLeft] = useState([]);
  const [selectedItemsLeft, setSelectedItemsLeft] = useState([]);
  const [selectedItemsRight, setSelectedItemsRight] = useState([]);
  const [checkBoxSelected, setCheckBoxSelected] = useState(false);

  useEffect(() => {
    if (selectedKey && selectedKey != null) {
      if (selectedKey.isAddSubscriptions === 'Y') {
        setCheckBoxSelected(true);
      } else {
        setCheckBoxSelected(false);
      }
    }
  }, [selectedKey]);

  useEffect(() => {
    const items = activeRoles.map((role, index) => {
      const items = {
        ...role,
        itemId: index,
        text: role.name,
        selected: false,
        children: [],
      };
      return items;
    });
    const data =
      availableRoles &&
      availableRoles.filter(role => {
        return !activeRoles.some(
          sel => sel.id === role.id || role.activeStatus === 'N'
        );
      });
    const items2 = data.map((role, index) => {
      const items = {
        ...role,
        itemId: index + activeRoles.length,
        text: role.name,
        selected: false,
        children: [],
        disabled: true,
      };
      return items;
    });
    setItemsLeft([...items, ...items2]);
  }, [activeRoles]);
  useEffect(() => {
    const items = activeEntitlements.map((entitlement, index) => {
      const items = {
        ...entitlement,
        itemId: index,
        text: entitlement.name,
        selected: false,
        children: [],
      };
      return items;
    });
    const data =
      availableEntitlements &&
      availableEntitlements.filter(ent => {
        return !activeEntitlements.some(
          sel => sel.id === ent.id || ent.activeStatus === 'N'
        );
      });
    const items2 = data.map((entitlement, index) => {
      const items = {
        ...entitlement,
        itemId: index + activeEntitlements.length,
        text: entitlement.name,
        selected: false,
        children: [],
        disabled: true,
      };
      return items;
    });
    setItemsRight([...items, ...items2]);
  }, [activeEntitlements]);
  const filterFromUserPermission = (modules, userModules) => {
    const filteredModules = [];
    _.map(modules, module => {
      const userModule = _.find(
        userModules,
        item => item.moduleId === module.moduleId
      );
      if (userModule) {
        const permissions = [];
        module.permissions.map(permission => {
          const hasPermission = userModule.permissions.find(
            item => item.id === permission.id
          );
          if (hasPermission) {
            permissions.push(permission);
          }
          return false;
        });
        const data = {
          ...module,
          permissions,
        };

        filteredModules.push(data);
      }
    });
    return filteredModules;
  };
  const handleExpendEntTree = (e, id, hasChild, position) => {
    e.stopPropagation();
    let positionItem = _.cloneDeep(itemsRight);
    if (position === 'right') {
      positionItem = _.cloneDeep(itemsRight);
    }
    if (hasChild) {
      const items = _.map(positionItem, item => {
        let children = item.children;
        if (item.id === id) {
          children = [];
        }
        const data = {
          ...item,
          children,
        };
        return data;
      });
      setItemsRight(items);
    } else {
      getSubscriptionDetails(accountDetail.accountId, id).then(response => {
        const items = _.map(positionItem, item => {
          let children = item.children;
          if (response && item.id === id) {
            children = response.studyGroup;
          }
          const data = {
            ...item,
            children,
          };
          return data;
        });
        setItemsRight(items);
      });
    }
  };
  const handleExpendRoleTree = (e, id, hasChild) => {
    e.stopPropagation();
    const positionItem = _.cloneDeep(itemsLeft);
    if (hasChild) {
      const items = _.map(positionItem, item => {
        let children = item.children;
        if (item.id === id) {
          children = [];
        }
        const data = {
          ...item,
          children,
        };
        return data;
      });
      setItemsLeft(items);
    } else {
      getRoleDetails(id).then(response => {
        const items = _.map(positionItem, item => {
          let children = item.children;
          if (response && item.id === id) {
            if (
              accountDetail.userPermission &&
              accountDetail.userPermission.length > 0
            ) {
              children = filterFromUserPermission(
                response.modules,
                accountDetail.userPermission
              );
            } else {
              children = response.modules;
            }
          }
          const data = {
            ...item,
            children,
          };
          return data;
        });
        setItemsLeft(items);
      });
    }
  };
  const handleLeftPanelClick = (itemId, clearExisting, shiftKey) => {
    let selectedItems = [];
    if (!shiftKey) {
      if (!clearExisting) {
        selectedItems = selectedItemsLeft;
      }
      selectedItems.push(parseInt(itemId, 10));
      setSelectedItemsLeft(selectedItems);
    } else {
      selectedItems = selectedItemsLeft;
      let lastItem = selectedItemsLeft.pop();
      let currentItemId = itemId;
      if (lastItem > currentItemId) {
        const temp = lastItem;
        lastItem = currentItemId;
        currentItemId = temp;
      }
      itemsLeft.map(item => {
        if (
          item.itemId >= lastItem &&
          item.itemId <= parseInt(currentItemId, 10)
        ) {
          selectedItems.push(item.itemId);
        }
        return item;
      });
      setSelectedItemsLeft(selectedItems);
    }
  };
  const handleRightPanelClick = (itemId, clearExisting, shiftKey) => {
    let selectedItems = [];
    if (!shiftKey) {
      if (!clearExisting) {
        selectedItems = selectedItemsRight;
      }
      selectedItems.push(parseInt(itemId, 10));
      setSelectedItemsRight(selectedItems);
    } else {
      selectedItems = selectedItemsRight;
      let lastItem = selectedItemsRight.pop();
      let currentItemId = itemId;
      if (lastItem > currentItemId) {
        const temp = lastItem;
        lastItem = currentItemId;
        currentItemId = temp;
      }
      itemsRight.map(item => {
        if (
          item.itemId >= lastItem &&
          item.itemId <= parseInt(currentItemId, 10)
        ) {
          selectedItems.push(item.itemId);
        }
        return item;
      });
      setSelectedItemsRight(selectedItems);
    }
  };
  return (
    <div className="activation-view">
      <div className="accounts-details-card-header">
        <div className="role-title">
          <h4>View Activation Code</h4>
        </div>
      </div>
      <div className="activation-box">
        <div className="multi-select-search-component">
          <div>
            <span className="activation-header">
              {' '}
              Activation Key{' '}
              <span className="activation-header-value">
              {`********************************${selectedKey.activationKey}`}
                <button
                  type="button"
                  onClick={() =>
                    CopyDataToClipBoard(selectedKey, true, getActivationKey)
                  }
                  className="table-cell-button activationKey-copy"
                >
                  <CopyIcon />
                </button>
              </span>
            </span>
		        <div style={{ width: '45rem', float: 'right' }}>
              <FormControlLabel
                style={{ float: 'right' }}
                control={
                  <Checkbox
                    data-test="AutocodeCheckBox"
                    className="ac--checkbox"
                    checked={checkBoxSelected}
                    icon={<IconCheckboxEmpty stroke="#6F6F6F" />}
                    checkedIcon={
                      <IconCheckboxCheck
                        fill="#DADADA"
                        stroke="#DADADA"
                        opacity="0"
                      />
                    }
                    color="primary"
                    disabled
                  />
                }
                label={
                  <CheckLabel>
                    <span style={{ fontSize: '1.25rem' }}>
                      Update Key with latest subscription
                    </span>
                  </CheckLabel>
                }
              />
            </div>
          </div>
          <div className="add-user-form--row" style={{ clear: 'both' }}>
            <div className="add-user-form--col">
              <div className="base-left-label">Selected Role(s)</div>
              <ListItems
                items={itemsLeft}
                handleExpendTree={handleExpendRoleTree}
                handleSelection={handleLeftPanelClick}
                selectedItems={selectedItemsLeft}
                position="left"
              />
            </div>
            <div className="add-user-form--col">
              <div className="base-left-label">Selected Subscription(s)</div>
              <EntListItems
                items={itemsRight}
                handleExpendTree={handleExpendEntTree}
                handleSelection={handleRightPanelClick}
                selectedItems={selectedItemsRight}
                position="right"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
ViewActivationKey.propTypes = {
  accountDetail: PropTypes.instanceOf(Object),
  selectedKey: PropTypes.instanceOf(Object),
  activeRoles: PropTypes.arrayOf(PropTypes.object),
  activeEntitlements: PropTypes.arrayOf(PropTypes.object),
  availableRoles: PropTypes.arrayOf(PropTypes.object),
  availableEntitlements: PropTypes.arrayOf(PropTypes.object),
};
export default ViewActivationKey;
